import {Stack} from '@mui/material';
import {ReactNode, useEffect} from 'react';
import CenteredText from '../../components/centeredText/CenteredText';
import HelpButton from '../../components/helpButton/HelpButton';
import useGetAllAccountToken, {HookAccountToken} from '../../hook/useGetAllAccountToken';
import {HelpTutorialEnum, helpTutorialMap} from '../../variables/helpTutorial';
import EtsyHeader from './EtsyHeader';

export interface WithEtsyAccountProps {
  featureName?: string;
  helpTutorialEnum: HelpTutorialEnum;

  component: (selectedAccount: HookAccountToken | undefined) => ReactNode;
}

export default function WithEtsyAccount({component, featureName, helpTutorialEnum}: WithEtsyAccountProps) {
  const {accounts, selectedAccount, setSelectedAccount, refetchAccounts} = useGetAllAccountToken();

  useEffect(() => {
    if (accounts.length === 1) {
      setSelectedAccount(accounts[0]);
    }
  }, [accounts, setSelectedAccount]);

  return (
    <Stack direction="column" spacing={2} sx={{p: 3}}>
      {featureName && (
        <CenteredText
          text={featureName}
          variant="h5"
          endComponent={<HelpButton {...helpTutorialMap[helpTutorialEnum]} />}
        />
      )}
      <EtsyHeader
        accounts={accounts}
        selectedAccount={selectedAccount}
        setSelectedAccount={setSelectedAccount}
        refetchAccounts={refetchAccounts}
      />
      {component(selectedAccount)}
    </Stack>
  );
}
